import React from "react";
import LeagueHub, { SECTIONS } from "./LeagueHub";
import { useSectionParam } from "../utils/useSectionParam";

/** Hub for a single sport (e.g. MBL Soccer) with fixtures / standings / stats tabs. */
const SportLeagueHub = ({ title, sport, standingsCaption }) => {
  const [section, setSection] = useSectionParam(SECTIONS.map((s) => s.key));
  return (
    <LeagueHub
      sport={sport}
      label={title}
      caption={standingsCaption}
      section={section}
      onSectionChange={setSection}
    />
  );
};

export default SportLeagueHub;
